import styled, { createGlobalStyle } from 'styled-components'
import Backdrop from '@material-ui/core/Backdrop'
import GridLayout, { WidthProvider } from 'react-grid-layout'
import { basicColor, sys } from '@netbasequid/theme'
import { AUTO_ATTR_KEY, AutomationId } from '../../../utils/automationUtil'

export const ToggleLabel = styled.label`
  display: flex;
  align-items: center;
  cursor: pointer;
  white-space: nowrap;
`

export const StyledLabelText = styled.div`
  font-weight: 500;
  font-size: 14px;
  line-height: 22px;
  color: ${({ displayTheme }) =>
    displayTheme === 'dark' ? basicColor.GRAY_300 : basicColor.GRAY_1100};
  margin-right: 4px;
`

export const StyledGridLayout = styled(WidthProvider(GridLayout))`
  background-color: inherit;
`

export const StyledWidgetContainer = styled.div`
  box-sizing: border-box;
  height: 100%;
  display: flex;
  flex-direction: column;
  background-color: ${({ displayTheme }) =>
    displayTheme === 'dark' ? basicColor.GRAY_1380 : basicColor.GRAY_100};
  padding: 0 24px 24px 24px;
`

export const StyledWidgetOperations = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
`
export const StyledOperationSection = styled.div`
  display: flex;
  flex-direction: row;
`

export const StyledBackdrop = styled(Backdrop)`
  z-index: 9999 !important;
  background-color: rgba(0, 0, 0, 0.5) !important;
`

export const StyledDashboardMain = styled.div.attrs({
  [AUTO_ATTR_KEY]: AutomationId.dashboard.main
})`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  padding: ${({ isPresentationMode }) => (isPresentationMode ? '16px 32px' : '20px')};
  width: 100%;
  min-height: 100%;
  color: ${({ displayTheme }) =>
    displayTheme === 'dark' ? basicColor.GRAY_100 : basicColor.GRAY_1400};
  background-color: ${({ displayTheme }) =>
    displayTheme === 'dark' ? basicColor.GRAY_1500 : basicColor.GRAY_200};
  .react-grid-layout {
    position: relative;
    transition: height 200ms ease;
  }
  .react-grid-item {
    transition: all 200ms ease;
    transition-property: left, top;
  }

  .react-grid-item.cssTransforms {
    transition-property: transform;
  }
  .react-grid-item.resizing {
    z-index: 1;
    will-change: width, height;
  }

  .react-grid-item.react-draggable-dragging {
    transition: none;
    z-index: 3;
    will-change: transform;
  }

  .react-grid-item.dropping {
    visibility: hidden;
  }

  .react-grid-item.react-grid-placeholder {
    background: #808080;
    opacity: 0.2;
    transition: all 200ms ease;
    z-index: 2;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    -o-user-select: none;
    user-select: none;
  }
`

export const StyledDashboardContent = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const StyledGrid = styled.div.attrs({ [AUTO_ATTR_KEY]: AutomationId.widget.grid })`
  cursor: ${({ editingFields }) => (editingFields ? 'grab' : 'initial')};
  .react-resizable-handle {
    ${({ editingFields }) =>
      !editingFields &&
      `
       display: none;
     `}
    position: absolute;
    width: 20px;
    height: 20px;
    bottom: 0;
    right: 0;
    background: url('data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBzdGFuZGFsb25lPSJubyI/Pg08IS0tIEdlbmVyYXRvcjogQWRvYmUgRmlyZXdvcmtzIENTNiwgRXhwb3J0IFNWRyBFeHRlbnNpb24gYnkgQWFyb24gQmVhbGwgKGh0dHA6Ly9maXJld29ya3MuYWJlYWxsLmNvbSkgLiBWZXJzaW9uOiAwLjYuMSAgLS0+DTwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+DTxzdmcgaWQ9IlVudGl0bGVkLVBhZ2UlMjAxIiB2aWV3Qm94PSIwIDAgNiA2IiBzdHlsZT0iYmFja2dyb3VuZC1jb2xvcjojZmZmZmZmMDAiIHZlcnNpb249IjEuMSINCXhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHhtbDpzcGFjZT0icHJlc2VydmUiDQl4PSIwcHgiIHk9IjBweCIgd2lkdGg9IjZweCIgaGVpZ2h0PSI2cHgiDT4NCTxnIG9wYWNpdHk9IjAuMzAyIj4NCQk8cGF0aCBkPSJNIDYgNiBMIDAgNiBMIDAgNC4yIEwgNCA0LjIgTCA0LjIgNC4yIEwgNC4yIDAgTCA2IDAgTCA2IDYgTCA2IDYgWiIgZmlsbD0iIzAwMDAwMCIvPg0JPC9nPg08L3N2Zz4=');
    background-position: bottom right;
    padding: 0 3px 3px 0;
    background-repeat: no-repeat;
    background-origin: content-box;
    box-sizing: border-box;
    cursor: se-resize;
  }
`

export const StyledDashboardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 32px;
  margin-bottom: 16px;
`

export const StyledDashboardTitleContainer = styled.div`
  display: flex;
  height: 32px;
  box-sizing: border-box;
`

export const StyledDashboardTitle = styled.div`
  display: flex;
  align-items: center;
  font-size: 14px;
  line-height: 22px;
  font-weight: 400;
  color: ${({ displayTheme }) =>
    displayTheme === 'dark' ? basicColor.GRAY_300 : basicColor.GRAY_1100};
`

export const StyledDashboardController = styled.div.attrs({
  [AUTO_ATTR_KEY]: AutomationId.dashboard.controller
})`
  display: flex;
  height: 100%;
  align-items: center;
  gap: 8px;
`

export const StyledButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  width: 32px;
  height: 32px;
  /* padding: 5px 10px; */
  border: ${({ displayTheme }) => (displayTheme === 'dark' ? '#8F9BA3' : basicColor.GRAY_800)};
  background: ${({ displayTheme }) =>
    displayTheme === 'dark' ? basicColor.GRAY_300 : basicColor.GRAY_1100};
  color: ${({ displayTheme }) =>
    displayTheme === 'dark' ? basicColor.GRAY_300 : basicColor.GRAY_1100};
  cursor: pointer;
`
export const GlobalStyleForDashboard = createGlobalStyle`
  body {
    background-color: ${({ displayTheme }) =>
      displayTheme === 'dark' ? basicColor.GRAY_1500 : basicColor.GRAY_200};
  }
`

export const Copyright = styled.div`
  margin-top: auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 16px;

  family: var(--large-font-family);
  font-size: ${sys.typescale[12].size};
  line-height: ${sys.typescale[12].lineHeight};
  font-weight: ${sys.fontWeight.regular};
  color: ${({ mode }) => sys[mode].text.placeholder};
  text-align: right;
`
